// Ein Auswahlfeld für „wer kümmert sich?" — überall gleich: beim Anlegen einer
// Wiedervorlage (Kundenakte, Anruffenster) und beim Umverteilen in der Liste.
//
// Drei Fälle in EINEM Feld, weil das alte Häkchen „Mir zuweisen" nur zwei
// kannte (mir / offen für alle) und Sharina (27.08.2026) direkt an eine
// Kollegin zuweisen wollte:
//   ''        → offen für alle (niemandem zugewiesen)
//   eigene ID → mir
//   andere ID → dieser Person
//
// Lädt die Liste nicht (alte Datenbank, Netz weg), bleiben „Mir zuweisen" und
// „offen für alle" wählbar — also genau das alte Verhalten, nichts blockiert.
import { useMitarbeiter, type MitarbeiterOption } from '../../lib/mitarbeiter';

export const OFFEN_FUER_ALLE = '';

interface Props {
  /** '' = offen für alle, sonst die User-ID des zuständigen Mitarbeiters. */
  wert: string;
  onChange: (wert: string) => void;
  /** Eigene User-ID — steht als „Mir zuweisen" an erster Stelle. */
  eigeneId?: string | null;
  style?: React.CSSProperties;
  disabled?: boolean;
  'aria-label'?: string;
  title?: string;
}

export function MitarbeiterAuswahl({
  wert, onChange, eigeneId, style, disabled, title, ...rest
}: Props) {
  const { mitarbeiter } = useMitarbeiter();
  const andere = mitarbeiter.filter((m) => m.id !== eigeneId);
  // Zugewiesen an jemanden, der (noch) nicht in der Liste steht — z. B. eine
  // inzwischen deaktivierte Kollegin. Der Wert darf nicht still verschwinden,
  // sonst schreibt ein Speichern ihn ungefragt um.
  const unbekannt = wert !== OFFEN_FUER_ALLE
    && wert !== eigeneId
    && !mitarbeiter.some((m) => m.id === wert);

  return (
    <select
      value={wert}
      onChange={(e) => onChange(e.target.value)}
      style={style}
      disabled={disabled}
      title={title}
      aria-label={rest['aria-label'] ?? 'Zuständig'}
    >
      {eigeneId && <option value={eigeneId}>Mir zuweisen</option>}
      <option value={OFFEN_FUER_ALLE}>— offen für alle —</option>
      {andere.map((m) => (
        <option key={m.id} value={m.id}>{name(m)}</option>
      ))}
      {unbekannt && <option value={wert}>zugewiesen (nicht mehr im Team)</option>}
    </select>
  );
}

function name(m: MitarbeiterOption): string {
  return m.display_name?.trim() || m.email || '—';
}
